import { map, catchError, publishReplay, refCount } from 'rxjs/operators';
import { environment } from './../../environments/environment';
import { AuthService } from './../auth/auth.service';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class WorkoutsService {
  userId;
  endPoint = '/user_strength_workouts';
  allEntries?: any;

  constructor(private http: HttpClient, private authService: AuthService) {
    this.authService.user.subscribe((user) => {
      if (user) {
        this.userId = user.id;
      }
    });
  }

  fetchAll(): Observable<any> {
    if (!this.userId) {
      return;
    }
    if (!this.allEntries) {
      let searchParams = new HttpParams();

      searchParams = searchParams.append('user_id', this.userId);
      searchParams = searchParams.append('sort', 'workout_date');
      searchParams = searchParams.append('order', 'DESC');
      return this.http
        .get<any>(environment.apiUrl + this.endPoint, {
          params: searchParams,
          responseType: 'json',
        })
        .pipe(
          map((responseData) => {
            return responseData._embedded.user_strength_workouts;
          }),
          catchError((errorRes) => {
            return throwError(errorRes);
          }),
          publishReplay(1),
          refCount()
        );
    }
    return this.allEntries;
  }

  fetch(id: number) {
    return this.http
      .get<any>(environment.apiUrl + this.endPoint + '/' + id, {
        responseType: 'json',
      })
      .pipe(
        map((responseData) => {
          return responseData;
        }),
        catchError((errorRes) => {
          return throwError(errorRes);
        })
      );
  }

  create(minutes, effort, workout_date) {
    this.clearCache();
    const postData = {
      user_id: this.userId,
      minutes,
      effort,
      workout_date,
    };
    return this.http
      .post<{ name: string }>(environment.apiUrl + this.endPoint, postData, {
        observe: 'response',
      })
      .pipe(
        map((responseData) => {
          return responseData.body;
        }),
        catchError((errorRes) => {
          return throwError(errorRes);
        })
      );
  }

  update(workoutId, minutes, effort, workout_date) {
    this.clearCache();
    const postData = {
      minutes,
      effort,
      workout_date,
    };
    return this.http.patch<{ name: string }>(
      environment.apiUrl + this.endPoint + '/' + workoutId,
      postData,
      {
        observe: 'response',
      }
    );
  }

  delete(id) {
    this.clearCache();
    return this.http.delete<{ name: string }>(
      environment.apiUrl + this.endPoint + '/' + id
    );
  }

  addExercise(workoutId, area, exercise, band, set1, set2, set3, effort) {
    this.clearCache();
    const postData = {
      user_id: this.userId,
      user_strength_workout_id: workoutId,
      area,
      name: exercise,
      band,
      set1,
      set2,
      set3,
      effort,
    };
    return this.http
      .post<{ name: string }>(
        environment.apiUrl + '/user_strength_workout_exercises',
        postData,
        {
          observe: 'response',
        }
      )
      .pipe(
        map((responseData) => {
          return responseData.body;
        }),
        catchError((errorRes) => {
          return throwError(errorRes);
        })
      );
  }

  fetchExercises(workoutId) {
    if (!this.userId) {
      return;
    }
    let searchParams = new HttpParams();

    searchParams = searchParams.append('user_id', this.userId);
    searchParams = searchParams.append('user_strength_workout_id', workoutId);
    searchParams = searchParams.append('sort', 'created');
    searchParams = searchParams.append('order', 'ASC');
    return this.http
      .get<any>(environment.apiUrl + '/user_strength_workout_exercises', {
        params: searchParams,
        responseType: 'json',
      })
      .pipe(
        map((responseData) => {
          return responseData._embedded.user_strength_workout_exercises;
        }),
        catchError((errorRes) => {
          return throwError(errorRes);
        })
      );
  }

  deleteExercise(id) {
    this.clearCache();
    return this.http.delete<{ name: string }>(
      environment.apiUrl + '/user_strength_workout_exercises/' + id
    );
  }
  clearCache() {
    this.allEntries = null;
  }
}
